var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhychoose3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zondicons:shield",
    clipPath: "url(#clip0_126_2726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.9 12.1C20.8276 13.4176 20.4402 14.6987 19.7703 15.8356C19.1004 16.9725 18.1675 17.9322 17.05 18.634L11 22L4.95001 18.634C3.83248 17.9322 2.89962 16.9725 2.22971 15.8356C1.5598 14.6987 1.17239 13.4176 1.10001 12.1V3.3C4.81801 3.3 8.25001 2.068 11 0C13.75 2.079 17.182 3.3 20.9 3.3V12.1ZM11 13.288L14.212 15.532L13.079 11.781L16.203 9.416L12.287 9.328L11 5.632L9.71301 9.328L5.79701 9.416L8.91001 11.77L7.77701 15.51L11 13.299V13.288Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_2726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhychoose3);
export default __webpack_public_path__ + "static/media/whychoose_3.881591be60dbb6afabb27d63302ec323.svg";
export { ForwardRef as ReactComponent };